<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <div>
      <h1 class="ts-uppercase ts-font-bold ts-text-lg">
        {{ $t('studentScoringEntry.studentList') }}
      </h1>
    </div>
    <table class="ts-w-full ts-rounded">
      <thead>
        <tr class="ts-bg-gray-200">
          <th valign="middle" rowspan="2" class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center"
            style="width: 10px;">
            {{ $t('numberic') }}
          </th>
          <th valign="middle" rowspan="2" class="ts-uppercase ts-whitespace-no-wrap ts-border ts-py-1 ts-px-3">
            {{ $t('studentScoringEntry.studentNameKH') }}
          </th>
          <th valign="middle" rowspan="2" class="ts-uppercase ts-whitespace-no-wrap ts-border ts-py-1 ts-px-3">
            {{ $t('studentScoringEntry.studentNameEN') }}
          </th>
          <th valign="middle" rowspan="2" class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-w-24 ts-text-center">
            {{ $t('studentScoringEntry.sex') }}
          </th>
          <th v-for="(entity, index) in tableHeaderSubject"
            class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center ts-whitespace-no-wrap"
            :colspan="entity.colspan" :key="index">
            <div class="ts-w-full ts-relative">
              <p>
                {{
                  // eslint-disable-next-line prettier/prettier
                  $i18n.locale == 'en' ? (entity.name ? entity.name : entity.name_native) : (entity.name_native ?
                    entity.name_native : entity.name)
                }}
              </p>
              <p v-if="model.score_sc_bas_id == 2">
                {{ showMaxScore(entity.id) }}
              </p>
            </div>
          </th>
          <th rowspan="2" class="ts-uppercase ts-border ts-py-1 ts-px-3 ts-text-center ts-whitespace-no-wrap">
            {{ $t('studentScoringEntry.comment') }}
          </th>
        </tr>
        <tr v-if="model.score_sc_bas_id == 1" class="ts-bg-gray-200">
          <template v-for="(entity, _index) in tableHeaderSubject">
            <th class="ts-border ts-px-3 ts-py-1" valign="bottom" style="width: 60px;"
              v-for="(item, index) in entity.items" :key="index + '_' + _index">
              <div class="ts-w-full ts-relative ts-text-center">
                <p>{{ item.name }}</p>
                <p>{{ showMaxScore(item.id) }}</p>
              </div>
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(student, index) in model.sc_item_subject_comp_list" :key="index" class="row-hover"
          :class="{
            'ts-text-blue-500': index === rowInput
          }"
        >
          <td class="ts-text-center ts-px-3 ts-border ts-w-6" :class="{
            'ts-bg-blue-100 ts-text-blue-500 ts-font-bold': index === rowInput
          }">
            {{ index + 1 }}
          </td>
          <td class="ts-text-left ts-px-3 ts-border ts-w-48">
            {{
              studentComputed(student.student_id)
                ? (studentComputed(student.student_id).first_name_kh || '') +
                ' ' +
                (studentComputed(student.student_id).last_name_kh || '')
                : ''
            }}
          </td>
          <td class="ts-text-left ts-px-3 ts-border ts-w-48 ts-relative">
            {{
              studentComputed(student.student_id)
                ? studentComputed(student.student_id).first_name_en +
                ' ' +
                studentComputed(student.student_id).last_name_en
                : ''
            }}
          </td>
          <td class="ts-text-center ts-px-3 ts-border">
            {{
              studentComputed(student.student_id)
                ? studentComputed(student.student_id).gender
                : ''
            }}
          </td>
          <td
            v-for="(score, scoreIndex) in student.scores.filter(sc => selectedSubjectId.id.includes(sc.sc_subject_id))"
            :key="scoreIndex" class="ts-border ts-px-3 ts-whitespace-no-wrap overflow-hidden ts-text-center ts-relative"
            style="width: 60px;">
            <i class="fas fa-lock ts-absolute ts-right-0 ts-mt-1 ts-mr-1 ts-text-gray-400" style="font-size: 8px;"
              v-if="score.is_released"></i>
            <input :ref="`student_${student.student_id}_${score.sc_item_subject_comp_id}`" v-if="!score.has_sub_items"
              v-model.number="score.actual_score"
              :disabled="score.is_released ? score.is_released : score.disabledInput" type="number" step="any"
              placeholder="-1" class="ts-w-full ts-px-2 ts-py-1 ts-outline-none ts-text-center" :class="{
                'ts-bg-red-100': score.actual_score === null || score.actual_score === undefined || score.actual_score === '',
                'ts-text-red-500': score.actual_score > score.max_score
              }" style="min-width: 40px;" :max="score.max_score"
              @input="validateInput(score, score.max_score, student)" @focus="onScoreFocus(index)" />
            <button v-if="score.has_sub_items" :disabled="score.is_released"
              class="ts-bg-blue-100 ts-w-12 ts-rounded ts-text-blue-500 focus:ts-outline-none hover:ts-shadow-md"
              style="padding: 2px 0;" @click="onScoreComponentEntry(student, score, index)">
              <i class="fas fa-plus"
                v-if="score.actual_score === null || score.actual_score === undefined || score.actual_score === ''"></i>
              <span v-else
                :class="{ 'ts-text-red-500': !score.scoring_id }"
              >{{ score.actual_score }}</span>
            </button>
          </td>
          <td class="ts-border ts-px-3 ts-whitespace-no-wrap ts-w-4 overflow-hidden ts-text-center">
            <a href="#" class="mr-2 text-primary" @click="onStudentRowClickComment(student)">
              <i class="fas fa-comment-alt"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <a-modal v-if="inputComment" v-model="inputComment" :title="$t('studentScoringEntry.comment')">
      <CommentComponents v-model="commentOnStudent" :scoringCycleId="model.scoring_cycle_id"
        :cycleValue="model.cycle_value" />
      <template v-slot:footer>
        <ts-button color="primary" @click="() => (inputComment = false)">{{
          $t('ok')
        }}</ts-button>
      </template>
    </a-modal>

    <!-- score component entries -->
    <a-modal v-if="scoreComponentEntry" v-model="scoreComponentEntry" :maskClosable="false"
      :title="$t('studentScoringEntry.scoreComponentEntry')" :footer="null">
      <ScoreComponentEntry :student="studentEntryCompoent" :component="componentForStudent"
        :subjectHeader="tableHeaderSubject" v-model="model" @set-score="onComponentSave"
        @close="onCloseSubComponentEntry" />
    </a-modal>


  </div>
</template>
<script>
import {
  getScore,
  getScoreComponentAverage
} from '@/api/student-scoring-table-entry'
import { mapMutations } from 'vuex'
import CommentComponents from './commentComponent.vue'
import ScoreComponentEntry from './score-component-entry.vue'

export default {
  name: 'tableEntryComponent',
  components: {
    CommentComponents,
    ScoreComponentEntry
  },
  props: {
    value: {},
    students: {
      type: Array,
      default: () => []
    },
    scoreEntities: {},
    selectedSubjectId: {},
    attendances: {},
  },
  data() {
    return {
      rowInput: undefined,
      inputComment: false,
      scoreComponentEntry: false,
      commentOnStudent: undefined,
      studentEntryCompoent: {},
      componentForStudent: {},
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    showMaxScore: vm => id => {
      if (id !== undefined && vm.model.sc_item_subject_comp_list) {
        const score = vm.model.sc_item_subject_comp_list[0]
        if (score) {
          const findMaxScore = score.scores.find(
            s => s.sc_item_subject_comp_id == id
          )
          return findMaxScore ? `${findMaxScore.max_score} (${findMaxScore.percentage}%)` : 'N/A'
        }
      }
      return undefined
    },
    studentComputed: vm => studentId => {
      if (studentId !== undefined) {
        return vm.students.find(s => s.student_id === studentId)
      }
      return undefined
    },
    tableHeaderSubject() {
      return this.scoreEntities
        .filter(en => {
          return this.selectedSubjectId.id.includes(en.id)
        })
        .filter(sc => {
          if (this.model.score_sc_bas_id == 1) {
            return sc.items.length > 0
          }
          return true
        })
        .map(el => ({
          id: el.id,
          name_native: el.name_native,
          name: el.name,
          colspan: this.model.score_sc_bas_id == 1 ? el.items.length : 0,
          items: el.items
        }))
    }
  },
  methods: {
    ...mapMutations('studentScoringEntryTable', ['isLoading']),
    validateInput(score, max, student) {
      if (score.actual_score > max) {
        this.$warning({
          centered: true,
          title: 'This is a warning message',
          content: `The entered score (${score.actual_score}) exceeds the maximum allowed (${max}).`,
          onOk: () => {
            score.actual_score = null
            const input = this.$refs[`student_${student.student_id}_${score.sc_item_subject_comp_id}`]
            if (input.length > 0) {
              input[0].focus()
            } else if (input.length == 0) {
              input.focus()
            }
          }
        });
      }
    },
    onStudentRowClickComment(student) {
      this.commentOnStudent = student
      this.inputComment = true
    },
    onCancelComment() {
      this.inputComment = false
      this.commentOnStudent = undefined
    },
    createRecordStudentRowEntryForNumberic() {
      this.model.sc_item_subject_comp_list = []
      this.students.forEach(student => {
        this.model.sc_item_subject_comp_list.push({
          student_id: student.student_id,
          st_class_id: student.st_class_id,
          comments: '',
          advisor_id: '',
          sc_stu_com_id: '',
          scores: []
        })
      })

      this.model.sc_item_subject_comp_list.forEach(student => {
        this.scoreEntities.forEach(subject => {
          this.model.program_structure_id = subject.program_structure_id
          // item base
          if (this.model.score_sc_bas_id == 1 && subject.items.length > 0) {
            const attendance = this.attendances[student.student_id] || {}
            const attendanceScore = attendance[subject.id]

            subject.items.forEach(item => {
              student.scores.push({
                disabledInput: item.is_auto_from_att,
                is_released: false,
                has_sub_items: item.has_sub_items,
                sc_subject_id: subject.id,
                scoring_id: 0,
                sc_item_subject_comp_id: item.sc_item_subject_comp_id,
                actual_score: item.is_auto_from_att ? attendanceScore : null,
                max_score: this.setMaxScore(item),
                percentage: item.percentage || 0
              })
            })
          }

          if (this.model.score_sc_bas_id == 2) {
            // subject base
            student.scores.push({
              is_released: false,
              disabledInput: false,
              has_sub_items: false,
              sc_subject_id: subject.id,
              scoring_id: 0,
              sc_item_subject_comp_id: subject.id,
              actual_score: null,
              max_score: this.setMaxScore(subject),
              percentage: subject.percentage || 0
            })
          }
        })
      })

      // fetch score record if scoring cycle not monthly
      if (this.model.scoring_cycle_id !== 1 && this.scoreEntities.length) {
        this.$nextTick(() => this.onCycleValue())
      }
    },
    setMaxScore(itemScore) {
      if (
        this.model.ac_category_id === 2 &&
        this.model.scoring_cycle_id === 1
      ) {
        // Sciense and monthly
        return itemScore.actual_score_sciense
      }
      if (
        this.model.ac_category_id === 2 &&
        [0, 2, 3].includes(this.model.scoring_cycle_id)
      ) {
        // Sciense and semester/term
        if (itemScore.enable_sciense && itemScore.enable_semester) {
          return itemScore.actual_score_sciense_semester
        }
        return itemScore.actual_score_sciense
      }

      // set max score for class no sciens class
      if (
        this.model.scoring_cycle_id === 1 &&
        this.model.ac_category_id !== 2
      ) {
        // montly
        return itemScore.actual_score
      }
      if (
        [0, 2, 3].includes(this.model.scoring_cycle_id) &&
        this.model.ac_category_id !== 2
      ) {
        // semester
        if (itemScore.enable_semester) {
          return itemScore.actual_score_semester
        }
        return itemScore.actual_score
      }
    },
    async onCycleValue() {
      if (
        !this.scoreEntities.length ||
        !this.model.cycle_value ||
        !this.model.program_structure_id
      )
        return
      this.isLoading(true)
      await getScore({
        class_id: this.model.class_id,
        scoring_cycle_id: this.model.scoring_cycle_id,
        cycle_value: this.model.cycle_value,
        program_structure_id: this.model.program_structure_id,
        score_sc_bas_id: this.model.score_sc_bas_id
      })
        .then(async ({ data }) => {
          const componentId = this.model.sc_item_subject_comp_list[0].scores.map(
            el => el.sc_item_subject_comp_id
          )
          await getScoreComponentAverage({
            class_id: this.model.class_id,
            ac_term_id: this.model.ac_term_id,
            grade_id: this.model.grade_id,
            scoring_cycle_id: this.model.scoring_cycle_id,
            cycle_value: this.model.cycle_value,
            subject_comp_id_list: componentId
          }).then(response => {
            if (this.model.score_type == 1) {
              // score type is numeric
              this.setValueExistingValueNumberic(data, response)
            }
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      this.isLoading(false)
    },
    setValueExistingValueNumberic(data, componentsAverage) {
      this.model.sc_item_subject_comp_list.forEach(student => {
        const itemScore = data[student.student_id]
        const average = Object.values(componentsAverage).length
          ? componentsAverage[student.student_id]
          : undefined

        student.scores.forEach(score => {
          let scoreAverage = undefined
          let actualScore = undefined

          if (average !== undefined) {
            scoreAverage = average.find(
              avg =>
                parseInt(avg.subject_comp_id) == score.sc_item_subject_comp_id
            )
          }
          if (itemScore !== undefined) {
            actualScore = itemScore.find(is => {
              // if score sc_base_id = 2 mean subject base
              if (this.model.score_sc_bas_id == 2) {
                return is.sc_subject_id == score.sc_subject_id
              }
              return is.sc_item_subject_comp_id == score.sc_item_subject_comp_id
            })
          }
          score.scoring_id =
            actualScore !== undefined ? actualScore.scoring_id : ''
          if (!score.disabledInput) {
            score.actual_score = this.setActualScore(actualScore, scoreAverage)
          }
          score.disabledInput = score.disabledInput
            ? score.disabledInput
            : scoreAverage !== undefined
          score.is_released = itemScore ? itemScore.find(el => el.submission_date) !== undefined : false
        })
        // reset comment
        student.comments = ''
        student.advisor_id = ''
        student.sc_stu_com_id = ''
      })
    },
    setActualScore(actualScore, averageScore) {
      if (averageScore !== undefined) {
        return parseFloat(averageScore.average_score)
      }
      if (actualScore !== undefined) {
        return actualScore.actual_score
      }
      return ''
    },
    onScoreComponentEntry(student, score, index) {
      this.rowInput = index
      this.componentForStudent = score
      this.studentEntryCompoent = this.students.find(s => s.student_id === student.student_id)
      this.scoreComponentEntry = true
    },
    onComponentSave(score) {
      this.scoreComponentEntry = false
      this.componentForStudent.actual_score = score ? score.average_score : undefined
      this.componentForStudent = {}
      this.studentEntryCompoent = {}
    },
    onCloseSubComponentEntry() {
      this.scoreComponentEntry = false
      this.componentForStudent = {}
      this.studentEntryCompoent = {}
    },
    onScoreFocus(index) {
      this.rowInput = index
    }
  },
  watch: {
    scoreEntities: {
      handler(value) {
        if (Array.isArray(value) && value.length) {
          this.createRecordStudentRowEntryForNumberic()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.row-hover:hover .comment {
  display: block !important;
}
</style>
